module.exports = __webpack_public_path__ + "static/media/default-avatar.7c6628a2.png";